// Next Diamonds - PDP Media Reorder (v3 — both layouts)
// Force the FIRST video to land at position 2 (top-right) of the gallery,
// regardless of the order set in Shopify admin. Works for:
//   1) Symmetry's collage layout (.product-media-collage > .product-media-collage__item)
//   2) Symmetry's slider layout   (.slider__grid > .slider__item)
// Desktop only: mobile keeps the default upload order.

console.log('[ND media reorder v3] script loaded');

(function () {
  'use strict';

  function isVideoItem(el) {
    if (el.classList.contains('media-type-video')) return true;
    if (el.getAttribute('data-media-type') === 'video') return true;
    if (el.querySelector('video, iframe, deferred-media')) return true;
    return false;
  }

  function pickGrid() {
    return (
      document.querySelector('.media-gallery .product-media-collage') ||
      document.querySelector('.media-gallery .slider__grid') ||
      null
    );
  }

  function reorder() {
    var grid = pickGrid();
    if (!grid) return;

    if (window.innerWidth < 1041) {
      // Mobile: clear our order so the carousel/collage uses upload order
      Array.prototype.slice.call(grid.children).forEach(function (item) {
        item.style.removeProperty('order');
      });
      return;
    }

    var items = Array.prototype.slice.call(grid.children);
    var images = items.filter(function (el) { return !isVideoItem(el); });
    var videos = items.filter(isVideoItem);
    if (videos.length === 0) return;

    // Order: image1, video1, video2, ..., remaining images.
    // In a 2-column grid this puts video1 at position 2 (top-right).
    var ordered = [];
    if (images.length > 0) ordered.push(images[0]);
    videos.forEach(function (v) { ordered.push(v); });
    images.slice(1).forEach(function (img) { ordered.push(img); });

    ordered.forEach(function (el, idx) {
      el.style.setProperty('order', String(idx), 'important');
    });

    // Make sure the parent IS a flex/grid that respects `order`
    var cs = window.getComputedStyle(grid);
    if (cs.display.indexOf('flex') === -1 && cs.display.indexOf('grid') === -1) {
      grid.style.setProperty('display', 'flex', 'important');
      grid.style.setProperty('flex-wrap', 'wrap', 'important');
    }
  }

  function init() {
    reorder();
    window.addEventListener('resize', reorder, { passive: true });
    var grid = pickGrid();
    if (grid) {
      var observer = new MutationObserver(reorder);
      observer.observe(grid, { childList: true });
    }
    // Also re-run when the gallery itself swaps (variant change with new media)
    var gallery = document.querySelector('.media-gallery');
    if (gallery) {
      var obs2 = new MutationObserver(reorder);
      obs2.observe(gallery, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
